/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/usermessage/usermessage_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:true});



/* ========== ~~~~~~~~~~ USER : MESSAGES : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const UserMessage = (props) => {
	sheet.update(props.hasRewardsComponent);
	return(
		<div className={`${sheet.classes.usermessage} usermessage`}>
			{props.children}
		</div>
	);
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default UserMessage;
